import React, { useEffect, useState } from 'react';
import { NavigationControl, Source, Layer } from 'react-map-gl';
import { useMapContext } from '../../../contexts/MapContext';
import {useLIDContext} from "../../../contexts/LIDContext";
// const MapControlPanel = ({ subcatchments, outfalls, selectedFeatureID, overflowData, stormMode, getColorLayer, getOutfallColor }) => {

const MapControlPanel = ({getColorLayer, getOutfallColor, getLIDLayer, getSelectedFeatureBorder, getBrushedSubcatchLayer}) => {
    const {
        geoJSONData,
        selectedFeature,
        stormMode,
        LIDMode,
    } = useMapContext();
    const {
        brushedSubcatchments,
        devPlanContent,
    } = useLIDContext();

    const [rerenderTrigger, setRerenderTrigger] = useState(false);

    useEffect(() => {
        if (brushedSubcatchments.size === 0) {
            setRerenderTrigger(prev => !prev);
        }
    }, [brushedSubcatchments]);

    const subcatchments = geoJSONData.subcatchments;
    const outfalls = geoJSONData.outfalls;
    const overflowData = geoJSONData.overflowData;
    const selectedFeatureID = selectedFeature.ID;


    return (
        <>
        <NavigationControl 
            visualizePitch={true} 
            position="bottom-left" 
        />

        {subcatchments && (
            <Source id="subcatchments-layer" type="geojson" data={subcatchments}>
                <Layer {...getColorLayer()} />
                <Layer {...getSelectedFeatureBorder()} />
                {brushedSubcatchments.size > 0 && (
                    <Layer {...getBrushedSubcatchLayer()} />
                )}
                {devPlanContent &&
                    (<Layer {...getLIDLayer()} />)
                }
            </Source>
        )}

        {outfalls && (
            <Source id="outfalls-layer" type="geojson" data={outfalls}>
            <Layer
                id="outfalls"
                type="circle"
                paint={{
                'circle-radius': 5,
                'circle-opacity': 1,
                'circle-color': [
                    'case',
                    ['==', ['get', 'NAME'], selectedFeatureID], 
                    '#ffa600', // Highlight color for the selected outfall
                    overflowData ? [
                    'match',
                    ['get', 'NAME'],
                    ...Object.keys(overflowData).flatMap(key => [key, getOutfallColor(overflowData[key], stormMode, overflowData, LIDMode)]),
                    '#bcad8f'  // Fallback color for unmatched outfalls
                    ] : '#bcad8f'  // Default color if overflowData is null
                ],
                }}
            />
            </Source>
        )}
        </>
    );
};

export default MapControlPanel;
